import React, { useState, useCallback, useEffect } from 'react';
import { orderApi } from '../../lib/orderApi';
import { goldButton } from '../PageShell';

const cfgLabel = { fontSize: '10px', letterSpacing: '2px', textTransform: 'uppercase', color: '#C9A84C', fontWeight: 600 };
const cfgInput = { background: '#0A0A0A', border: '1px solid rgba(201,168,76,0.25)', color: '#F5F5F0', padding: '9px 11px', fontSize: '13px', outline: 'none', width: '100%' };
const revCard = { background: '#0A0A0A', border: '1px solid rgba(201,168,76,0.18)', padding: '14px' };
const revNum = { fontFamily: "'Bebas Neue', sans-serif", fontSize: '26px', color: '#C9A84C', lineHeight: 1 };
const revLbl = { fontSize: '10px', letterSpacing: '1.5px', textTransform: 'uppercase', color: '#C2C1B6', marginTop: '4px' };

const AdminRevenue = ({ isOpen }) => {
  const [rev, setRev] = useState(null);
  const [revStart, setRevStart] = useState('');
  const [revEnd, setRevEnd] = useState('');

  const loadRevenue = useCallback(async (sOverride, eOverride) => {
    const st = sOverride !== undefined ? sOverride : revStart;
    const en = eOverride !== undefined ? eOverride : revEnd;
    const params = {};
    if (st) params.start = st;
    if (en) params.end = en;
    try {
      const { data } = await orderApi.get('/admin/revenue', { params });
      setRev(data);
    } catch {
      setRev(null);
    }
  }, [revStart, revEnd]);

  useEffect(() => {
    if (isOpen) loadRevenue();
  }, [isOpen, loadRevenue]);

  if (!isOpen) return null;

  return (
    <div className="mt-5 p-5" style={{ background: '#141414', border: '1px solid rgba(201,168,76,0.3)' }} data-testid="revenue-panel">
      <h3 className="font-display" style={{ fontSize: '18px', fontWeight: 700, color: '#F5F5F0' }}>Acumulación de pagos</h3>
      <div className="flex flex-wrap items-end gap-3 mt-3">
        <div>
          <label style={cfgLabel}>Desde (entrega)</label>
          <input
            type="date"
            value={revStart}
            onChange={(e) => setRevStart(e.target.value)}
            style={{ ...cfgInput, marginTop: '4px' }}
            data-testid="rev-start"
          />
        </div>
        <div>
          <label style={cfgLabel}>Hasta (entrega)</label>
          <input
            type="date"
            value={revEnd}
            onChange={(e) => setRevEnd(e.target.value)}
            style={{ ...cfgInput, marginTop: '4px' }}
            data-testid="rev-end"
          />
        </div>
        <button onClick={() => loadRevenue()} style={goldButton} data-testid="rev-apply">
          Filtrar
        </button>
        <button
          onClick={() => {
            setRevStart('');
            setRevEnd('');
            loadRevenue('', '');
          }}
          style={{ ...goldButton, opacity: 0.8 }}
          data-testid="rev-clear"
        >
          Todo
        </button>
      </div>
      {rev && (
        <>
          <div className="grid grid-cols-2 sm:grid-cols-5 gap-3 mt-4">
            <div style={revCard}>
              <div style={revNum} data-testid="rev-gross">${rev.gross_total.toFixed(2)}</div>
              <div style={revLbl}>Total cobrado</div>
            </div>
            <div style={revCard}>
              <div style={revNum} data-testid="rev-tax">${rev.tax_total.toFixed(2)}</div>
              <div style={revLbl}>Tax recolectado</div>
              {(rev.tax_by_rate || []).map((b) => (
                <div key={b.rate} className="font-body" style={{ fontSize: '11px', color: '#9A7522', marginTop: '2px' }} data-testid={`rev-tax-${b.label}`}>
                  {b.label}: ${b.amount.toFixed(2)}
                </div>
              ))}
            </div>
            <div style={revCard}>
              <div style={revNum} data-testid="rev-tips">${(rev.tips_total || 0).toFixed(2)}</div>
              <div style={revLbl}>Propinas</div>
            </div>
            <div style={revCard}>
              <div style={revNum}>${rev.net_total.toFixed(2)}</div>
              <div style={revLbl}>Neto (sin tax ni propina)</div>
            </div>
            <div style={revCard}>
              <div style={revNum} data-testid="rev-discounts">${(rev.discounts_total || 0).toFixed(2)}</div>
              <div style={revLbl}>Descuentos otorgados</div>
            </div>
            <div style={revCard}>
              <div style={revNum} data-testid="rev-count">{rev.order_count}</div>
              <div style={revLbl}>Pedidos</div>
            </div>
          </div>
          {rev.by_day.length > 0 && (
            <div className="mt-4">
              <p className="font-body uppercase" style={{ fontSize: '10px', letterSpacing: '2px', color: '#C9A84C' }}>
                Por semana de entrega
              </p>
              <div className="mt-2 space-y-1">
                {rev.by_day.map((d) => (
                  <div key={d.date} className="flex justify-between font-body" style={{ fontSize: '13px', color: '#C2C1B6' }}>
                    <span>{d.date} · {d.count} pedido(s)</span>
                    <span style={{ color: '#F5F5F0' }}>
                      ${d.total.toFixed(2)} <span style={{ color: '#9A7522' }}>(tax ${d.tax.toFixed(2)}{(d.tip || 0) > 0 ? ` · propina $${(d.tip || 0).toFixed(2)}` : ''})</span>
                    </span>
                  </div>
                ))}
              </div>
            </div>
          )}
          {(rev.tax_by_rate || []).length === 0 && (
            <p className="font-body mt-3" style={{ fontSize: '11px', color: '#9A7522' }}>
              El tax se calcula con los porcentajes por artículo (actualmente 0% hasta configurarlos).
            </p>
          )}
        </>
      )}
    </div>
  );
};

export default AdminRevenue;
